export const modeOptions = [
  {
    id: 'scatter',
    label: 'scatterplot',
  },
  { id: 'map', label: 'map' },
];

// Official upload on Jaar's Other People label; same 1:57:52 recording as the old local m4a.
export const soundcloudUrl =
  'https://soundcloud.com/otherpeoplerecords/csp06-nicolas-jaar-essential';
